export const USER_MANAGEMENT_HEAD_CELLS = [
  { id: 'displayName', center: false, disablePadding: false, label: 'Name' },
  { id: 'username', center: false, disablePadding: false, label: 'Username' },
  { id: 'role', center: false, disablePadding: false, label: 'Role' },
];

export const EMPLOYEE_COLORS = [
  { label: 'Soft Red', value: '#F4A6A6' },
  { label: 'Soft Coral', value: '#F6B8A1' },
  { label: 'Soft Orange', value: '#F6C79C' },
  { label: 'Soft Peach', value: '#F9D6B0' },
  { label: 'Soft Yellow', value: '#F4E0A1' },
  { label: 'Soft Lime', value: '#D4E4A8' },
  { label: 'Soft Green', value: '#A8D8B9' },
  { label: 'Soft Mint', value: '#A8E0D1' },
  { label: 'Soft Teal', value: '#A2D4D8' },
  { label: 'Soft Sky', value: '#AFCCE6' },
  { label: 'Soft Blue', value: '#A8B8E0' },
  { label: 'Soft Lavender', value: '#C4B8E0' },
  { label: 'Soft Purple', value: '#D2B3DC' },
  { label: 'Soft Pink', value: '#F2BCD1' },
  { label: 'Soft Rose', value: '#EBA9C0' },
  { label: 'Soft Beige', value: '#E6D3B3' },
];

export const ADD_EMPLOYEE_LABEL = 'Add Employee';

export const DEFAULT_SORT_BY_HEAD_CELL = 'name';
export const MANAGE_USERS_TITLE = 'Manage Employees';

export const ROLE_DASHBOARD = 'ROLE_DASHBOARD';

//ticket-out
export const ROLE_TICKET_OUT = 'ROLE_TICKET_OUT';
export const ROLE_TICKET_NFC = 'ROLE_TICKET_NFC';

//Security
export const ROLE_SECURITY = 'ROLE_SECURITY';

//customer
export const ROLE_CUSTOMER = 'ROLE_CUSTOMER';
export const ROLE_CUSTOMER_PRIVILEGIE = 'ROLE_CUSTOMER_PRIVILEGIE';
export const ROLE_CUSTOMER_MOBILE = 'ROLE_CUSTOMER_MOBILE';
export const ROLE_CUSTOMER_WALLET_PASS = 'ROLE_CUSTOMER_WALLET_PASS';

//raffle
export const ROLE_RAFFLE = 'ROLE_RAFFLE';
export const ROLE_RAFFLE_MOBILE = 'ROLE_RAFFLE_MOBILE';

//Reading
export const ROLE_READING = 'ROLE_READING';
export const ROLE_MACHINE_PICTURE = 'ROLE_MACHINE_PICTURE';
export const ROLE_ADD_MACHINE_READING = 'ROLE_ADD_MACHINE_READING';
export const ROLE_MASTER_READING = 'ROLE_MASTER_READING';

//Accounting
export const ROLE_ACCOUNTING = 'ROLE_ACCOUNTING';
export const ROLE_REPORT = 'ROLE_REPORT';
export const ROLE_CUSTOMER_LOAN_REPORT = 'ROLE_CUSTOMER_LOAN_REPORT';
export const ROLE_EMPLOYEE_SHORT_REPORT = 'ROLE_EMPLOYEE_SHORT_REPORT';
export const ROLE_ZELLE_REPORT = 'ROLE_ZELLE_REPORT';
export const ROLE_ATM_TRANSACTION = 'ROLE_ATM_TRANSACTION';
export const ROLE_OPEN_ALL_WEEKLY_REPORT = 'ROLE_OPEN_ALL_WEEKLY_REPORT';

//settings
export const ROLE_SETTINGS = 'ROLE_SETTINGS';
export const ROLE_RULES = 'ROLE_RULES';
export const ROLE_COMPANY = 'ROLE_COMPANY';
export const ROLE_MACHINE = 'ROLE_MACHINE';
export const ROLE_GAME = 'ROLE_GAME';
export const ROLE_ASSIGN_MACHINE = 'ROLE_ASSIGN_MACHINE';
export const ROLE_MANAGE_BONUS = 'ROLE_MANAGE_BONUS';
export const ROLE_MANAGE_USERS = 'ROLE_MANAGE_USERS';

export const ROLE_MASTER_ADMIN = 'ROLE_MASTER_ADMIN';
export const ROLE_ADMIN = 'ROLE_ADMIN';

export const PARENT_ROLE_MAP = {
  ROLE_CUSTOMER: [ROLE_CUSTOMER_PRIVILEGIE, ROLE_CUSTOMER_MOBILE],
  ROLE_RAFFLE: [ROLE_RAFFLE_MOBILE],
  ROLE_TICKET_OUT: [ROLE_TICKET_NFC],
  ROLE_READING: [
    ROLE_MACHINE_PICTURE,
    ROLE_ADD_MACHINE_READING,
    ROLE_MASTER_READING,
  ],
  ROLE_ACCOUNTING: [
    ROLE_REPORT,
    ROLE_ATM_TRANSACTION,
    ROLE_OPEN_ALL_WEEKLY_REPORT,
    ROLE_CUSTOMER_LOAN_REPORT,
    ROLE_EMPLOYEE_SHORT_REPORT,
    ROLE_ZELLE_REPORT,
  ],
  ROLE_SETTINGS: [
    ROLE_COMPANY,
    ROLE_RULES,
    ROLE_MACHINE,
    ROLE_GAME,
    ROLE_ASSIGN_MACHINE,
    ROLE_MANAGE_BONUS,
    ROLE_MANAGE_USERS,
  ],
};

export const CHILD_ROLE_MAP = {
  ROLE_CUSTOMER_PRIVILEGIE: [ROLE_CUSTOMER],
  ROLE_CUSTOMER_WALLET_PASS: [ROLE_CUSTOMER],
  ROLE_MACHINE_PICTURE: [ROLE_READING],
  ROLE_ADD_MACHINE_READING: [ROLE_READING],
  ROLE_MASTER_READING: [ROLE_READING],
  ROLE_CUSTOMER_MOBILE: [ROLE_CUSTOMER],
  ROLE_RAFFLE_MOBILE: [ROLE_RAFFLE],
  ROLE_REPORT: [ROLE_ACCOUNTING],
  ROLE_ATM_TRANSACTION: [ROLE_ACCOUNTING],

  ROLE_OPEN_ALL_WEEKLY_REPORT: [ROLE_ACCOUNTING],

  ROLE_CUSTOMER_LOAN_REPORT: [ROLE_ACCOUNTING],
  ROLE_EMPLOYEE_SHORT_REPORT: [ROLE_ACCOUNTING],
  ROLE_ZELLE_REPORT: [ROLE_ACCOUNTING],
  ROLE_COMPANY: [ROLE_SETTINGS],
  ROLE_RULES: [ROLE_SETTINGS],
  ROLE_MACHINE: [ROLE_SETTINGS],
  ROLE_GAME: [ROLE_SETTINGS],
  ROLE_ASSIGN_MACHINE: [ROLE_SETTINGS],
  ROLE_MANAGE_BONUS: [ROLE_SETTINGS],
  ROLE_MANAGE_USERS: [ROLE_SETTINGS],
};

export const ROLE_DEPTH_AND_ORDER = {
  ROLE_SECURITY: 0,
  ROLE_DASHBOARD: 0,
  ROLE_CUSTOMER: 0,
  ROLE_CUSTOMER_PRIVILEGIE: 1,
  ROLE_CUSTOMER_MOBILE: 1,
  ROLE_CUSTOMER_WALLET_PASS: 1,
  ROLE_TRANSACTION: 0,
  ROLE_TICKET_OUT: 0,
  ROLE_TICKET_NFC: 1,
  ROLE_BONUS: 0,
  ROLE_RAFFLE: 0,
  ROLE_RAFFLE_MOBILE: 1,
  ROLE_NOTE: 0,
  ROLE_CHECK_IN_OUT: 0,
  ROLE_POINT_WATCHING: 0,
  ROLE_EMPLOYEE_SESSION: 0,
  ROLE_READING: 0,
  ROLE_MACHINE_PICTURE: 1,
  ROLE_ADD_MACHINE_READING: 1,
  ROLE_MASTER_READING: 1,
  ROLE_ACCOUNTING: 0,
  ROLE_REPORT: 1,
  ROLE_ATM_TRANSACTION: 2,
  ROLE_OPEN_ALL_WEEKLY_REPORT: 2,

  ROLE_CUSTOMER_LOAN_REPORT: 1,
  ROLE_EMPLOYEE_SHORT_REPORT: 1,
  ROLE_ZELLE_REPORT: 1,
  ROLE_SETTINGS: 0,
  ROLE_COMPANY: 1,
  ROLE_RULES: 1,
  ROLE_MACHINE: 1,
  ROLE_GAME: 1,
  ROLE_ASSIGN_MACHINE: 1,
  ROLE_MANAGE_BONUS: 1,
  ROLE_MANAGE_USERS: 1,
};

export const ROLE_NUVE_MASTER_ADMIN = 'ROLE_OWNER';
export const ROLE_TECH_ADMIN = 'ROLE_TECH_ADMIN';

export function getDisplayLabel(label) {
  const mapping = {
    'Manage Users': 'Manage Employees',
    Report: 'Weekly Report',
    'Machine Picture': 'Machine Reading Pictures',
    'Add Machine Reading': 'Start New Reading Session',
    'Master Reading': 'Reading Sessions Record',
    'Atm Transaction': 'ATM Transaction',
    'Customer Privilegie': 'Customer Phone Number Access',
    'Customer Mobile': 'Mobile Match & Photo Capture',
    'Ticket Nfc': 'Mobile Ticket NFC',
  };

  return mapping[label] || label;
}

export const cleanLayoutPaths = [
  '/login',
  '/404',
  '/privacy-policy',
  '/terms-and-conditions',
  '/gate-check-in',
  '/claim',
  '/security',
  '/session-complete',
];

export const SELECT_COMPANY_SERVICES =
  'Choose the services to grant to the company:';
export const SELECT_LOCATION_SERVICES =
  'Choose the locations to grant access to:';
export const SELECT_SERVICES = 'Choose the services the employee can access:';
export const PASSWORD_ACTION = 'Generate Password';
export const PASSWORD_SUCCESS_MESSAGE =
  'Password successfully generated and copied to clipboard!';
export const SAVE_ACTION = 'Save';
export const SAVING = 'Saving Changes...';

export const SUCCESS = 'success';

export const CANCEL = 'Cancel';

export const ROWS_PER_PAGE_LABEL = 'Results';
export const DEFAULT_ROWS_PER_PAGE = 50;

export const MANAGE_USERS_TOOLBAR_TITLE = 'Employees';

export const TIME_ZONE = [
  'America/Chicago',
  'US/Aleutian',
  'US/Arizona',
  'US/Central',
  'US/East-Indiana',
  'US/Eastern',
  'US/Hawaii',
  'US/Indiana-Starke',
  'US/Michigan',
  'US/Mountain',
  'US/Pacific',
  'US/Pacific-New',
  'US/Samoa',
];
